import {
    FormControl,
    FormHelperText,
    MenuItem,
    Select,
    Chip,
    Box,
} from "@mui/material"
import React from "react"


const SchadenhistorieFilter = ({
    widget,
    value = [],
    onValueChange,
    disabled,
    options = [],
}) => {
    const onMultiSelectChange = event => {
        const {
            target: {value: selectedValues},
        } = event
        if (selectedValues?.length > 3) {
            return null
        }

        const newValue =
            typeof selectedValues === "string"
                ? selectedValues.split(",")
                : selectedValues

        onValueChange(newValue)
    }

    const handleDelete = chipToDelete => event => {
        event.stopPropagation()
        onValueChange(value.filter(entry => entry !== chipToDelete))
    }

    return (
        <FormControl fullWidth>
            <Select
                id={widget.id}
                key={widget.id}
                multiple
                value={value ?? []}
                onChange={onMultiSelectChange}
                className={widget.className}
                disabled={disabled}
                renderValue={selected => (
                    <Box
                        sx={{
                            display: "flex",
                            flexWrap: "nowrap",
                            overflowX: "scroll",
                            gap: 0.5,
                        }}
                    >
                        {selected.map(selectedValue => {
                            const selectedOption = options.find(
                                option =>
                                    option.ereignisnummer === selectedValue,
                            )
                            return (
                                <Chip
                                    key={selectedValue}
                                    label={
                                        selectedOption?.ereignisnummer ||
                                        selectedValue
                                    }
                                    onDelete={handleDelete(selectedValue)}
                                    onMouseDown={(event) => event.stopPropagation()}
                                />
                            )
                        })}
                    </Box>
                )}
            >
                {Array.isArray(options) &&
                    options.map(option => (
                        <MenuItem
                            key={option?.id}
                            value={option.ereignisnummer}
                            disabled={option?.disabled}
                        >
                            {option?.ereignisnummer}
                        </MenuItem>
                    ))}
            </Select>
            {widget.helperText && (
                <FormHelperText>{widget.helperText}</FormHelperText>
            )}
        </FormControl>
    )
}

export default SchadenhistorieFilter
